import {Field} from "react-final-form";
import PropTypes from "prop-types";
import React from "react";
import {useTranslation} from "react-i18next";
import {FiHelpCircle} from "react-icons/fi";
import EnigooToolTip from "./EnigooToolTip";

export const EnigooEmailField = ({
                                     inline = false,
                                     label,
                                     name,
                                     placeholder = 'test@nonexist.com',
                                     outsideClassName = "w-full",
                                     mandatory = false,
                                     toolTip = null,
                                     toolTipPosition = "right"
                                 }) => {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;
    const {t} = useTranslation()
    const required = value => {
        if (!mandatory && !value) {
            return undefined;
        } else if (mandatory && value === "" || value === null) {
            return t("basics.requireField");
        } else if (value !== "" && value !== null && !emailRegex.test(value)) {
            return t("basics.emailNotValid");
        } else if (value && !emailRegex.test(value)) {
            return t("basics.emailNotValid");
        } else {
            return undefined;
        }
    }

    return (
        <div className={outsideClassName}>
            <div className={`form-element ${inline ? 'form-element-inline' : ''}`}>
                <Field name={name} validate={required}>
                    {({input, meta}) => (
                        <>
                            <div className="form-label  flex flex-row">{label}
                                {toolTip && <>
                                    <FiHelpCircle data-tip data-for={"_tooltip_" + name} key={name}
                                                  className={"ml-2 text-red-900"} size={18}/>
                                    <EnigooToolTip content={toolTip} id={"_tooltip_" + name} place={toolTipPosition}/>

                                </>}</div>
                            <input
                                {...input}
                                name={name}
                                type={"email"}
                                className={(meta.error) ? "form-input form-input-invalid" : "form-input"}
                                placeholder={placeholder}
                            />
                            {meta.error && <div className="form-error">{meta.error}</div>}
                        </>
                    )}
                </Field>

            </div>
        </div>
    )
}
EnigooEmailField.propTypes = {
    inline: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    outsideClassName: PropTypes.string
}
